// This file is auto-generated by @hey-api/openapi-ts

import { type Options as ClientOptions, type TDataShape, type Client, formDataBodySerializer } from './client';
import type { SearchVoucherCodeData, SearchVoucherCodeResponses, GetExcelDataVoucherCodeData, GetExcelDataVoucherCodeResponses, DeleteVoucherCodeData, DeleteVoucherCodeResponses, CreateVoucherCodeData, CreateVoucherCodeResponses, UpdateShippingHolidayListData, UpdateShippingHolidayListResponses, GetShippingHolidayListData, GetShippingHolidayListResponses, DetailShippingHolidayListData, DetailShippingHolidayListResponses, DeleteShippingHolidayData, DeleteShippingHolidayResponses, CreateShippingHolidayListData, CreateShippingHolidayListResponses, UpdateShippingFeeGroupData, UpdateShippingFeeGroupResponses, SearchShippingFeeGroupData, SearchShippingFeeGroupResponses, DetailShippingFeeGroupData, DetailShippingFeeGroupResponses, DeleteShippingFeeGroupData, DeleteShippingFeeGroupResponses, CreateShippingFeeGroupData, CreateShippingFeeGroupResponses, UpdateShippingDawnAreaData, UpdateShippingDawnAreaResponses, SearchShippingDawnAreaData, SearchShippingDawnAreaResponses, DetailShippingDawnAreaData, DetailShippingDawnAreaResponses, DeleteShippingDawnAreaData, DeleteShippingDawnAreaResponses, CreateShippingDawnAreaData, CreateShippingDawnAreaResponses, CreateExcelShippingDawnAreaData, CreateExcelShippingDawnAreaResponses, UpdateShippingBlockAreaData, UpdateShippingBlockAreaResponses, SearchShippingBlockAreaData, SearchShippingBlockAreaResponses, DetailShippingBlockAreaData, DetailShippingBlockAreaResponses, DeleteShippingBlockAreaData, DeleteShippingBlockAreaResponses, CreateShippingBlockAreaData, CreateShippingBlockAreaResponses, CreateExcelShippingBlockAreaData, CreateExcelShippingBlockAreaResponses, GetProductionOutputListData, GetProductionOutputListResponses, UpdateProductVariantForNaverData, UpdateProductVariantForNaverResponses, UpdateProductIngredientData, UpdateProductIngredientResponses, UpdateProductDeliveryDateData, UpdateProductDeliveryDateResponses, UpdateProductAllergyData, UpdateProductAllergyResponses, SyncProductData, SyncProductResponses, SyncMesProductData, SyncMesProductResponses, SyncMesProductListData, SyncMesProductListResponses, SyncAllProductListData, SyncAllProductListResponses, SearchProductData, SearchProductResponses, GetProductListData, GetProductListResponses, GetProductWithCategoryListData, GetProductWithCategoryListResponses, GetProductVariantOptionListData, GetProductVariantOptionListResponses, GetProductVariantDetailListData, GetProductVariantDetailListResponses, GetProductIngredientListData, GetProductIngredientListResponses, GetProductAllergyListData, GetProductAllergyListResponses, GetProductDeliveryDateListData, GetProductDeliveryDateListResponses, GetCafe24ProductListData, GetCafe24ProductListResponses, DeleteProductIngredientListData, DeleteProductIngredientListResponses, DeleteProductAllergyListData, DeleteProductAllergyListResponses, UpdateRegularOrderMealData, UpdateRegularOrderMealResponses, SearchOrderItemBenefitData, SearchOrderItemBenefitResponses, SearchOrderItemBenefitHistoryData, SearchOrderItemBenefitHistoryResponses, GetExcelDataOrderItemBenefitHistoryData, GetExcelDataOrderItemBenefitHistoryResponses, DeleteOrderItemBenefitHistoryData, DeleteOrderItemBenefitHistoryResponses, CreateOrderItemBenefitHistoryData, CreateOrderItemBenefitHistoryResponses, GetExcelDataOrderItemBenefitData, GetExcelDataOrderItemBenefitResponses, SendOrderListData, SendOrderListResponses, UpdateMemberCustomerGroupData, UpdateMemberCustomerGroupResponses, SearchMemberCustomerGroupData, SearchMemberCustomerGroupResponses, RevertMemberCustomerGroupData, RevertMemberCustomerGroupResponses, RejectMemberCustomerGroupData, RejectMemberCustomerGroupResponses, DetailMemberCustomerGroupData, DetailMemberCustomerGroupResponses, ApproveMemberCustomerGroupData, ApproveMemberCustomerGroupResponses, UpdateMealPlanListData, UpdateMealPlanListResponses, GetMealPlanListData, GetMealPlanListResponses, GetExcelDataMealPlanData, GetExcelDataMealPlanResponses, DetailMealPlanData, DetailMealPlanResponses, DetailMealPlanListData, DetailMealPlanListResponses, DeleteMealPlanData, DeleteMealPlanResponses, CreateMealPlanListData, CreateMealPlanListResponses, CreateExcelMealPlanData, CreateExcelMealPlanResponses, UpdateIngredientData, UpdateIngredientResponses, SyncIngredientListData, SyncIngredientListResponses, SearchIngredientData, SearchIngredientResponses, GetIngredientListData, GetIngredientListResponses, DetailIngredientData, DetailIngredientResponses, DeleteIngredientData, DeleteIngredientResponses, CreateIngredientData, CreateIngredientResponses, UploadImageData, UploadImageResponses, UploadImagesData, UploadImagesResponses, GetDpsExcelDataData, GetDpsExcelDataResponses, UpdateCustomerGroupData, UpdateCustomerGroupResponses, UpdateCustomerGroupActiveData, UpdateCustomerGroupActiveResponses, SearchCustomerGroupData, SearchCustomerGroupResponses, GetUnregisteredCustomerGroupListData, GetUnregisteredCustomerGroupListResponses, GetCustomerGroupModelListData, GetCustomerGroupModelListResponses, DetailCustomerGroupData, DetailCustomerGroupResponses, DeleteCustomerGroupData, DeleteCustomerGroupResponses, CreateCustomerGroupData, CreateCustomerGroupResponses, GetUnregisteredCategoryListData, GetUnregisteredCategoryListResponses, GetShippingFeeGroupCategoryListData, GetShippingFeeGroupCategoryListResponses, RefreshTokenData, RefreshTokenResponses, UpdateAllergyData, UpdateAllergyResponses, SyncAllergyListData, SyncAllergyListResponses, SearchAllergyData, SearchAllergyResponses, GetAllergyListData, GetAllergyListResponses, DetailAllergyData, DetailAllergyResponses, DeleteAllergyData, DeleteAllergyResponses, CreateAllergyData, CreateAllergyResponses, AuthorizeCafe24Data, AuthorizeCafe24Responses, CheckAuthorizeCafe24Data, CheckAuthorizeCafe24Responses } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * 조회
 */
export const searchVoucherCode = <ThrowOnError extends boolean = false>(options: Options<SearchVoucherCodeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SearchVoucherCodeResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/voucher-code/search',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 엑셀 데이터 조회
 */
export const getExcelDataVoucherCode = <ThrowOnError extends boolean = false>(options: Options<GetExcelDataVoucherCodeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetExcelDataVoucherCodeResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/voucher-code/excel',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 삭제
 */
export const deleteVoucherCode = <ThrowOnError extends boolean = false>(options: Options<DeleteVoucherCodeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DeleteVoucherCodeResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/voucher-code/delete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 등록
 */
export const createVoucherCode = <ThrowOnError extends boolean = false>(options: Options<CreateVoucherCodeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateVoucherCodeResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/voucher-code/create',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 리스트 수정
 */
export const updateShippingHolidayList = <ThrowOnError extends boolean = false>(options: Options<UpdateShippingHolidayListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UpdateShippingHolidayListResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/shipping_holiday/update/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 리스트 조회
 */
export const getShippingHolidayList = <ThrowOnError extends boolean = false>(options: Options<GetShippingHolidayListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetShippingHolidayListResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/shipping_holiday/get/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 상세 리스트 조회
 */
export const detailShippingHolidayList = <ThrowOnError extends boolean = false>(options: Options<DetailShippingHolidayListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DetailShippingHolidayListResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/shipping_holiday/detail/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 삭제
 */
export const deleteShippingHoliday = <ThrowOnError extends boolean = false>(options: Options<DeleteShippingHolidayData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DeleteShippingHolidayResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/shipping_holiday/delete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 리스트 등록
 */
export const createShippingHolidayList = <ThrowOnError extends boolean = false>(options: Options<CreateShippingHolidayListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateShippingHolidayListResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/shipping_holiday/create/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 수정
 */
export const updateShippingFeeGroup = <ThrowOnError extends boolean = false>(options: Options<UpdateShippingFeeGroupData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UpdateShippingFeeGroupResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/shipping_fee_group/update',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 조회
 */
export const searchShippingFeeGroup = <ThrowOnError extends boolean = false>(options: Options<SearchShippingFeeGroupData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SearchShippingFeeGroupResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/shipping_fee_group/search',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 상세 조회
 */
export const detailShippingFeeGroup = <ThrowOnError extends boolean = false>(options: Options<DetailShippingFeeGroupData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DetailShippingFeeGroupResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/shipping_fee_group/detail',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 삭제
 */
export const deleteShippingFeeGroup = <ThrowOnError extends boolean = false>(options: Options<DeleteShippingFeeGroupData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DeleteShippingFeeGroupResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/shipping_fee_group/delete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 등록
 */
export const createShippingFeeGroup = <ThrowOnError extends boolean = false>(options: Options<CreateShippingFeeGroupData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateShippingFeeGroupResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/shipping_fee_group/create',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 수정
 */
export const updateShippingDawnArea = <ThrowOnError extends boolean = false>(options: Options<UpdateShippingDawnAreaData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UpdateShippingDawnAreaResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/shipping_dawn_area/update',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 조회
 */
export const searchShippingDawnArea = <ThrowOnError extends boolean = false>(options: Options<SearchShippingDawnAreaData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SearchShippingDawnAreaResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/shipping_dawn_area/search',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 상세 조회
 */
export const detailShippingDawnArea = <ThrowOnError extends boolean = false>(options: Options<DetailShippingDawnAreaData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DetailShippingDawnAreaResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/shipping_dawn_area/detail',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 삭제
 */
export const deleteShippingDawnArea = <ThrowOnError extends boolean = false>(options: Options<DeleteShippingDawnAreaData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DeleteShippingDawnAreaResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/shipping_dawn_area/delete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 등록
 */
export const createShippingDawnArea = <ThrowOnError extends boolean = false>(options: Options<CreateShippingDawnAreaData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateShippingDawnAreaResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/shipping_dawn_area/create',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 엑셀 등록
 */
export const createExcelShippingDawnArea = <ThrowOnError extends boolean = false>(options: Options<CreateExcelShippingDawnAreaData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateExcelShippingDawnAreaResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/shipping_dawn_area/create/excel',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 수정
 */
export const updateShippingBlockArea = <ThrowOnError extends boolean = false>(options: Options<UpdateShippingBlockAreaData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UpdateShippingBlockAreaResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/shipping_block_area/update',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 조회
 */
export const searchShippingBlockArea = <ThrowOnError extends boolean = false>(options: Options<SearchShippingBlockAreaData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SearchShippingBlockAreaResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/shipping_block_area/search',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 상세 조회
 */
export const detailShippingBlockArea = <ThrowOnError extends boolean = false>(options: Options<DetailShippingBlockAreaData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DetailShippingBlockAreaResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/shipping_block_area/detail',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 삭제
 */
export const deleteShippingBlockArea = <ThrowOnError extends boolean = false>(options: Options<DeleteShippingBlockAreaData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DeleteShippingBlockAreaResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/shipping_block_area/delete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 등록
 */
export const createShippingBlockArea = <ThrowOnError extends boolean = false>(options: Options<CreateShippingBlockAreaData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateShippingBlockAreaResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/shipping_block_area/create',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 엑셀 등록
 */
export const createExcelShippingBlockArea = <ThrowOnError extends boolean = false>(options: Options<CreateExcelShippingBlockAreaData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateExcelShippingBlockAreaResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/shipping_block_area/create/excel',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 생산량 내역 조회
 */
export const getProductionOutputList = <ThrowOnError extends boolean = false>(options: Options<GetProductionOutputListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetProductionOutputListResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/production/output/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 상품 스마트스토어 추가 정보 수정
 */
export const updateProductVariantForNaver = <ThrowOnError extends boolean = false>(options: Options<UpdateProductVariantForNaverData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UpdateProductVariantForNaverResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/product/update/variant/naver',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 상품-원재료 수정
 */
export const updateProductIngredient = <ThrowOnError extends boolean = false>(options: Options<UpdateProductIngredientData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UpdateProductIngredientResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/product/update/ingredient',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 상품 배송일자 수정
 */
export const updateProductDeliveryDate = <ThrowOnError extends boolean = false>(options: Options<UpdateProductDeliveryDateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UpdateProductDeliveryDateResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/product/update/delivery_date',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 상품-알레르기 수정
 */
export const updateProductAllergy = <ThrowOnError extends boolean = false>(options: Options<UpdateProductAllergyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UpdateProductAllergyResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/product/update/allergy',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 상품 동기화
 */
export const syncProduct = <ThrowOnError extends boolean = false>(options: Options<SyncProductData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SyncProductResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/product/sync',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * mes 상품 동기화
 */
export const syncMesProduct = <ThrowOnError extends boolean = false>(options: Options<SyncMesProductData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SyncMesProductResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/product/sync/mes',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * mes 상품 리스트 동기화
 */
export const syncMesProductList = <ThrowOnError extends boolean = false>(options?: Options<SyncMesProductListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SyncMesProductListResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/product/sync/mes/list',
        ...options
    });
};

/**
 * 전체 상품 동기화
 */
export const syncAllProductList = <ThrowOnError extends boolean = false>(options?: Options<SyncAllProductListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SyncAllProductListResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/product/sync/all',
        ...options
    });
};

/**
 * 상품 조회
 */
export const searchProduct = <ThrowOnError extends boolean = false>(options: Options<SearchProductData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SearchProductResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/product/search',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 상품 리스트 조회
 */
export const getProductList = <ThrowOnError extends boolean = false>(options: Options<GetProductListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetProductListResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/product/get/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 카테고리 포함 상품 리스트 조회
 */
export const getProductWithCategoryList = <ThrowOnError extends boolean = false>(options?: Options<GetProductWithCategoryListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<GetProductWithCategoryListResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/product/get/list/with/category',
        ...options
    });
};

/**
 * 상품 추가 옵션 리스트
 */
export const getProductVariantOptionList = <ThrowOnError extends boolean = false>(options: Options<GetProductVariantOptionListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetProductVariantOptionListResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/product/get/list/variant/option',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 상품 추가 정보 상세 리스트
 */
export const getProductVariantDetailList = <ThrowOnError extends boolean = false>(options: Options<GetProductVariantDetailListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetProductVariantDetailListResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/product/get/list/variant/detail',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 상품-원재료 리스트 조회
 */
export const getProductIngredientList = <ThrowOnError extends boolean = false>(options: Options<GetProductIngredientListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetProductIngredientListResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/product/get/list/ingredient',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 상품-알레르기 리스트 조회
 */
export const getProductAllergyList = <ThrowOnError extends boolean = false>(options: Options<GetProductAllergyListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetProductAllergyListResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/product/get/list/allergy',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 상품 배송일자 조회
 */
export const getProductDeliveryDateList = <ThrowOnError extends boolean = false>(options: Options<GetProductDeliveryDateListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetProductDeliveryDateListResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/product/get/delivery_date',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 카페24 상품 리스트 조회
 */
export const getCafe24ProductList = <ThrowOnError extends boolean = false>(options: Options<GetCafe24ProductListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetCafe24ProductListResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/product/get/cafe24/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 상품-원재료 삭제
 */
export const deleteProductIngredientList = <ThrowOnError extends boolean = false>(options: Options<DeleteProductIngredientListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DeleteProductIngredientListResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/product/delete/ingredient',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 상품-알레르기 삭제
 */
export const deleteProductAllergyList = <ThrowOnError extends boolean = false>(options: Options<DeleteProductAllergyListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DeleteProductAllergyListResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/product/delete/allergy',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 식단 수정
 */
export const updateRegularOrderMeal = <ThrowOnError extends boolean = false>(options: Options<UpdateRegularOrderMealData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UpdateRegularOrderMealResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/order-item-option/update/meal',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 검색
 */
export const searchOrderItemBenefit = <ThrowOnError extends boolean = false>(options: Options<SearchOrderItemBenefitData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SearchOrderItemBenefitResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/order-item-benefit/search',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 이력 검색
 */
export const searchOrderItemBenefitHistory = <ThrowOnError extends boolean = false>(options: Options<SearchOrderItemBenefitHistoryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SearchOrderItemBenefitHistoryResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/order-item-benefit/history/search',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 이력 엑셀 데이터 조회
 */
export const getExcelDataOrderItemBenefitHistory = <ThrowOnError extends boolean = false>(options: Options<GetExcelDataOrderItemBenefitHistoryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetExcelDataOrderItemBenefitHistoryResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/order-item-benefit/history/excel',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 이력 삭제
 */
export const deleteOrderItemBenefitHistory = <ThrowOnError extends boolean = false>(options: Options<DeleteOrderItemBenefitHistoryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DeleteOrderItemBenefitHistoryResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/order-item-benefit/history/delete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 이력 등록
 */
export const createOrderItemBenefitHistory = <ThrowOnError extends boolean = false>(options: Options<CreateOrderItemBenefitHistoryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateOrderItemBenefitHistoryResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/order-item-benefit/history/create',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 엑셀 데이터 조회
 */
export const getExcelDataOrderItemBenefit = <ThrowOnError extends boolean = false>(options: Options<GetExcelDataOrderItemBenefitData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetExcelDataOrderItemBenefitResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/order-item-benefit/excel',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * mes 주문 리스트
 */
export const sendOrderList = <ThrowOnError extends boolean = false>(options?: Options<SendOrderListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SendOrderListResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/mes/order',
        ...options
    });
};

/**
 * 수정
 */
export const updateMemberCustomerGroup = <ThrowOnError extends boolean = false>(options: Options<UpdateMemberCustomerGroupData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UpdateMemberCustomerGroupResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/member-customer-group/update',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 조회
 */
export const searchMemberCustomerGroup = <ThrowOnError extends boolean = false>(options: Options<SearchMemberCustomerGroupData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SearchMemberCustomerGroupResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/member-customer-group/search',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 원복
 */
export const revertMemberCustomerGroup = <ThrowOnError extends boolean = false>(options: Options<RevertMemberCustomerGroupData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RevertMemberCustomerGroupResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/member-customer-group/revert',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 거절
 */
export const rejectMemberCustomerGroup = <ThrowOnError extends boolean = false>(options: Options<RejectMemberCustomerGroupData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RejectMemberCustomerGroupResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/member-customer-group/reject',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 상세조회
 */
export const detailMemberCustomerGroup = <ThrowOnError extends boolean = false>(options: Options<DetailMemberCustomerGroupData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DetailMemberCustomerGroupResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/member-customer-group/detail',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 승인
 */
export const approveMemberCustomerGroup = <ThrowOnError extends boolean = false>(options: Options<ApproveMemberCustomerGroupData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApproveMemberCustomerGroupResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/member-customer-group/approve',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 리스트 수정
 */
export const updateMealPlanList = <ThrowOnError extends boolean = false>(options: Options<UpdateMealPlanListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UpdateMealPlanListResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/meal-plan/update/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 리스트 조회
 */
export const getMealPlanList = <ThrowOnError extends boolean = false>(options: Options<GetMealPlanListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetMealPlanListResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/meal-plan/get/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 엑셀 데이터 조회
 */
export const getExcelDataMealPlan = <ThrowOnError extends boolean = false>(options: Options<GetExcelDataMealPlanData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetExcelDataMealPlanResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/meal-plan/excel',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 상세 조회
 */
export const detailMealPlan = <ThrowOnError extends boolean = false>(options: Options<DetailMealPlanData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DetailMealPlanResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/meal-plan/detail',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 상세 리스트 조회
 */
export const detailMealPlanList = <ThrowOnError extends boolean = false>(options: Options<DetailMealPlanListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DetailMealPlanListResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/meal-plan/detail/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 삭제
 */
export const deleteMealPlan = <ThrowOnError extends boolean = false>(options: Options<DeleteMealPlanData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DeleteMealPlanResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/meal-plan/delete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 리스트 등록
 */
export const createMealPlanList = <ThrowOnError extends boolean = false>(options: Options<CreateMealPlanListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateMealPlanListResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/meal-plan/create/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 엑셀 등록
 */
export const createExcelMealPlan = <ThrowOnError extends boolean = false>(options: Options<CreateExcelMealPlanData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateExcelMealPlanResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/meal-plan/create/excel',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 수정
 */
export const updateIngredient = <ThrowOnError extends boolean = false>(options: Options<UpdateIngredientData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UpdateIngredientResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/ingredient/update',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * mes 동기화
 */
export const syncIngredientList = <ThrowOnError extends boolean = false>(options?: Options<SyncIngredientListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SyncIngredientListResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/ingredient/sync/mes/list',
        ...options
    });
};

/**
 * 조회
 */
export const searchIngredient = <ThrowOnError extends boolean = false>(options: Options<SearchIngredientData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SearchIngredientResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/ingredient/search',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 조회
 */
export const getIngredientList = <ThrowOnError extends boolean = false>(options?: Options<GetIngredientListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<GetIngredientListResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/ingredient/get/list',
        ...options
    });
};

/**
 * 상세 조회
 */
export const detailIngredient = <ThrowOnError extends boolean = false>(options: Options<DetailIngredientData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DetailIngredientResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/ingredient/detail',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 삭제
 */
export const deleteIngredient = <ThrowOnError extends boolean = false>(options: Options<DeleteIngredientData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DeleteIngredientResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/ingredient/delete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 등록
 */
export const createIngredient = <ThrowOnError extends boolean = false>(options: Options<CreateIngredientData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateIngredientResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/ingredient/create',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 파일 업로드
 */
export const uploadImage = <ThrowOnError extends boolean = false>(options?: Options<UploadImageData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<UploadImageResponses, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/file',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * 파일 리스트 업로드
 */
export const uploadImages = <ThrowOnError extends boolean = false>(options?: Options<UploadImagesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<UploadImagesResponses, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/file/list',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * 엑셀 데이터 가져오기
 */
export const getDpsExcelData = <ThrowOnError extends boolean = false>(options: Options<GetDpsExcelDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetDpsExcelDataResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/dps/excel',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 수정
 */
export const updateCustomerGroup = <ThrowOnError extends boolean = false>(options: Options<UpdateCustomerGroupData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UpdateCustomerGroupResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/customer-group/update',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 활성 상태 수정
 */
export const updateCustomerGroupActive = <ThrowOnError extends boolean = false>(options: Options<UpdateCustomerGroupActiveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UpdateCustomerGroupActiveResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/customer-group/update/active',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 조회
 */
export const searchCustomerGroup = <ThrowOnError extends boolean = false>(options: Options<SearchCustomerGroupData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SearchCustomerGroupResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/customer-group/search',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 등록 되지 않은 카페24 회원 그룹 리스트 조회
 */
export const getUnregisteredCustomerGroupList = <ThrowOnError extends boolean = false>(options?: Options<GetUnregisteredCustomerGroupListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<GetUnregisteredCustomerGroupListResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/customer-group/get/list/unregistered',
        ...options
    });
};

/**
 * 카페24 회원 그룹 리스트 조회
 */
export const getCustomerGroupModelList = <ThrowOnError extends boolean = false>(options?: Options<GetCustomerGroupModelListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<GetCustomerGroupModelListResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/customer-group/get/list/model',
        ...options
    });
};

/**
 * 상세 조회
 */
export const detailCustomerGroup = <ThrowOnError extends boolean = false>(options: Options<DetailCustomerGroupData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DetailCustomerGroupResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/customer-group/detail',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 삭제
 */
export const deleteCustomerGroup = <ThrowOnError extends boolean = false>(options: Options<DeleteCustomerGroupData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DeleteCustomerGroupResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/customer-group/delete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 등록
 */
export const createCustomerGroup = <ThrowOnError extends boolean = false>(options: Options<CreateCustomerGroupData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateCustomerGroupResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/customer-group/create',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 등록 되지 않은 카테고리 리스트 조회
 */
export const getUnregisteredCategoryList = <ThrowOnError extends boolean = false>(options?: Options<GetUnregisteredCategoryListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<GetUnregisteredCategoryListResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/category/get/list/unregistered',
        ...options
    });
};

/**
 * 배송비 그룹 카테고리 리스트 조회
 */
export const getShippingFeeGroupCategoryList = <ThrowOnError extends boolean = false>(options?: Options<GetShippingFeeGroupCategoryListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<GetShippingFeeGroupCategoryListResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/category/get/list/shipping-fee-group',
        ...options
    });
};

/**
 * 토큰 갱신
 */
export const refreshToken = <ThrowOnError extends boolean = false>(options: Options<RefreshTokenData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RefreshTokenResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/auth/refresh-token',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 수정
 */
export const updateAllergy = <ThrowOnError extends boolean = false>(options: Options<UpdateAllergyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UpdateAllergyResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/allergy/update',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * mes 동기화
 */
export const syncAllergyList = <ThrowOnError extends boolean = false>(options?: Options<SyncAllergyListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SyncAllergyListResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/allergy/sync/mes/list',
        ...options
    });
};

/**
 * 조회
 */
export const searchAllergy = <ThrowOnError extends boolean = false>(options: Options<SearchAllergyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SearchAllergyResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/allergy/search',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 리스트 조회
 */
export const getAllergyList = <ThrowOnError extends boolean = false>(options?: Options<GetAllergyListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<GetAllergyListResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/allergy/get/list',
        ...options
    });
};

/**
 * 상세 조회
 */
export const detailAllergy = <ThrowOnError extends boolean = false>(options: Options<DetailAllergyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DetailAllergyResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/allergy/detail',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 삭제
 */
export const deleteAllergy = <ThrowOnError extends boolean = false>(options: Options<DeleteAllergyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DeleteAllergyResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/allergy/delete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 등록
 */
export const createAllergy = <ThrowOnError extends boolean = false>(options: Options<CreateAllergyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateAllergyResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/allergy/create',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 권한 코드 획득
 */
export const authorizeCafe24 = <ThrowOnError extends boolean = false>(options?: Options<AuthorizeCafe24Data, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AuthorizeCafe24Responses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/auth/cafe24',
        ...options
    });
};

/**
 * 액세스 토큰 발급
 */
export const checkAuthorizeCafe24 = <ThrowOnError extends boolean = false>(options: Options<CheckAuthorizeCafe24Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<CheckAuthorizeCafe24Responses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/auth/cafe24/check',
        ...options
    });
};